<p-tag [class.mouse-pointer]="clickable" [class.mouse-default]="!clickable" [class.inactive]="!active" [value]="value" [icon]="icon" [severity]="severity" [pTooltip]="toolTip" (click)="click()"></p-tag>
